import script from "./ChipsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipsEditor.vue?vue&type=script&setup=true&lang=js"

import "./ChipsEditor.vue?vue&type=style&index=0&id=13badc57&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13badc57"]])

export default __exports__